import styled from 'styled-components';
import { Col, Row, Skeleton, Upload } from 'antd';
import { DEFAULT_RISK_RPN_COLOR } from '@/utils/constants';

export const Content = styled(Col)`
	border-radius: 18px;
	padding: 30px 40px;
	background-color: #ffffff;
`;

export const CustomUpload = styled(Upload)`
	width: 100%;
	.ant-upload-select-picture-card {
		height: 270px !important;
		width: 200px !important;
		border-radius: 6px !important;
		border: 2px dashed ${DEFAULT_RISK_RPN_COLOR} !important;
		background-color: #ffffffcc !important;
	}
`;

export const IconWrapper = styled(Col)`
	font-size: 2rem;
	color: ${DEFAULT_RISK_RPN_COLOR};
`;

export const List = styled(Row)`
	display: flex;
	overflow-x: auto;
	flex-wrap: nowrap;
	padding-bottom: 1%;
	::-webkit-scrollbar {
		width: 1px;
		height: 8px;
	}
	::-webkit-scrollbar-track {
		background: #f1f1f1;
	}
	::-webkit-scrollbar-thumb {
		background-color: #d6d6d6;
		border-radius: 6px;
	}
	::-webkit-scrollbar-thumb:hover {
		background: #555;
	}
`;

export const ImageSkeleton = styled(Skeleton.Image)`
	width: 270px !important;
	height: 270px !important;
	border-radius: 6px;
`;
